import { Box, Typography } from "@mui/material";
import { FC } from "react";
import { AutocompleteItem } from "src/utils/response";

interface OwnProps {
    option: AutocompleteItem;
}

const AutocompleteListItem: FC<OwnProps> = ({ option }) => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="body1" sx={{ fontWeight: "fontWeightMedium" }}>
                {option.firstLine}
            </Typography>
            {option.secondLine && (
                <Typography
                    variant="body2"
                    sx={{ fontSize: 12, letterSpacing: 1, color: "text.disabled" }}
                >
                    {option.secondLine}
                </Typography>
            )}
            {option.thirdLine && (
                <Typography
                    variant="body2"
                    sx={{
                        fontSize: 12,
                        lineHeight: 1.3,
                        letterSpacing: 0.5,
                        color: "grey.600",
                        "& b": { fontWeight: "fontWeightRegular", color: "grey.900" },
                    }}
                >
                    {option.thirdLine}
                </Typography>
            )}
        </Box>
    );
};

export default AutocompleteListItem;
